export default "__VITE_ASSET__B36YYKjE__"